<template>
  <main>
    <div style="width: 70%" :class="{ 'form-group--error': validator.$error }">
      <div style="padding: 0 15px; margin-bottom: 10px; background: white; border: 1px solid #eee; border-radius: 11px">
        <img src="../../../assets/momentGraduationCap.png" style="width: 20px; vertical-align: sub; margin-right: 5px" />
        <strong>* {{ appCustomTextConst['Please select which EtonHouse school'] }}</strong>
        <div style="display: inline-block; margin-left: 10px; width: 50%">
          <select class="form-control ddl-sch-opt m-0" :value="selected" @change="changeSchoolOpt($event)">
            <option value="" selected disabled>Please select</option>
            <option v-for="(id, name) in schools" :value="id" :key="id">{{ name }}</option>
          </select>
        </div>
      </div>

      <div class="error requiredFieldsMsg" v-if="!validator.required" style="margin-bottom: 10px">
        <el-alert :title="getValidationMessageFromKey('selectOptSchool')" type="error"></el-alert>
      </div>
    </div>
    <SupportDocumentModal
      @handleClose="handleClose"
      title="Supporting Documents"
      :modal="modal"
      :preschoolInfo="preschoolInfo"
      :schools="schools"
      :selected="selected"
      :group="group"
    />
    <b-modal ref="showSupportingDocumentModal" title="Supporting Documents" hide-footer>
      <div v-if="selected && group === 'MIS'">
        <APFMISSupportingDocument />
      </div>
      <div v-else-if="selected && preschoolInfo">
        <ApfPreSupportingDocument :preschoolInfo="preschoolInfo" :schools="schools" :selected="selected" />
      </div>
      <div v-else>
        <ApfEhSupportingDocument :preschoolInfo="preschoolInfo" :schools="schools" :selected="selected" />
      </div>
    </b-modal>
  </main>
</template>

<script>
import { schools, getValidationMessageFromKey } from '../data.js'
import '../texts/supportingDocument/ApfMISSupportingDocument'
import appCustomTextConst from '@/pages/application/const/applicationCustomTextConst'
import apfConfig from '@/pages/application/config/apfConfig'
import SupportDocumentModal from '@/pages/application/modal/supportDocumentModal'

export default {
  components: { SupportDocumentModal },
  props: ['group', 'validator', 'errorMsg', 'school', 'preschoolInfo'],
  emits: ['change'],
  data() {
    return {
      apfConfig,
      schools,
      selected: '',
      appCustomTextConst,
      modal: {},
    }
  },
  mounted() {
    switch (this.group) {
      case 'MIS':
        this.schools = apfConfig?.MIS?.schools
        break
      case 'PRE':
        this.schools = apfConfig?.PRE?.schools
        break
      default:
        this.schools = apfConfig?.default?.schools
    }
  },
  methods: {
    getValidationMessageFromKey,
    handleClose() {
      this.modal = {}
    },
    async changeSchoolOpt(event) {
      const newSchool = event.target.value
      const confirmed = await this.$bvModal.msgBoxConfirm(this.prompt)
      if (confirmed) {
        this.selected = newSchool
        this.$emit('change', this.selected)
        this.modal = { name: 'showSupportingDocumentModal' }
      } else {
        event.target.value = this.selected
      }
    },
  },
  watch: {
    school(val) {
      this.selected = val
    },
  },
  computed: {
    prompt() {
      return this.group === 'MIS'
        ? 'Please confirm that you would like to apply to this campus?'
        : 'Please confirm that you would like to apply to this school?'
    },
  },
}
</script>
